'use client';

import { InputHTMLAttributes } from 'react';
import classnames from 'classnames';

interface Props extends InputHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
  role?: string;
  rows?: number;
}

const Textarea = ({ invalid = false, disabled = false, ...props }: Props) => {
  const className = classnames({
    'bg-input-background-color': true,
    'text-input-text-color': true,
    block: true,
    'w-full': true,
    'py-1.5': true,
    'px-2.5': true,
    'bg-clip-padding': true,
    rounded: true,
    border: true,
    'border-input-border-color': true,
    'disabled:opacity-60': true,
    'disabled:outline-none': true,
    'focus:outline-none': true,
    'focus:border': true,
    'focus:border-input-focus-color': true,
    'focus:bg-input-background-color': true,
    'focus:text-input-focus-color': true,
    'placeholder:text-input-placeholder-text-color': true,
    '!border-input-border-invalid-color': invalid,
    '!focus:border-input-border-invalid-color': invalid,
  });

  return (
    <textarea
      readOnly={disabled}
      autoComplete="off"
      className={className}
      disabled={disabled}
      {...props}
    />
  );
};

export default Textarea;
